(function (Drupal, once) {
  Drupal.behaviors.ajaxOverrides = {
    attach() {
      if (typeof Drupal.Ajax === 'function') {
        once('ajax-overrides', 'body').forEach(function () {
          // Override throbber so all ajax indicators are full screen.
          Drupal.Ajax.prototype.setProgressIndicatorThrobber =
            Drupal.Ajax.prototype.setProgressIndicatorFullscreen;

          Drupal.theme.ajaxProgressIndicatorFullscreen = function () {
            return '<div class="progress-fullscreen"><div class="screen"></div><div class="icon"></div></div>';
          };
        });
        if (typeof Drupal.Ajax.prototype.autologoutRefresh === 'function') {
          if (typeof Drupal.Ajax.prototype.autologoutRefreshWrapped === 'undefined') {
            Drupal.Ajax.prototype.autologoutRefreshWrapped =
                Drupal.Ajax.prototype.autologoutRefresh;
          }
          // Have to keep monkey-patching this as else autologout puts it back ...
          Drupal.Ajax.prototype.autologoutRefresh = function (timerFunction) {
            const progressType = this.progress.type;
            this.progress.type = 'none';
            this.autologoutRefreshWrapped(timerFunction);
            this.progress.type = progressType;
          };
        }
      }
    },
  };
}(Drupal, once));
